import React, { Component } from 'react';
import EventTeams from './EventTeams';


class EventCard extends Component {
    constructor(props) {
        super(props);
        // this.isSelected = this.isSelected.bind(this);
    }
    render() {

        return (<figure className='event'>
            <div className='event-image' style={{background: `linear-gradient(90deg, ${this.props.event.team_one_colour}, ${this.props.event.team_two_colour})`}}>

                {/* <img src={`/img/bg/bg-${parseInt(this.props.event.eventId) % 13}.jpg`} /> */}
            </div>
            <figcaption>
                <EventTeams event={this.props.event}></EventTeams>
                <div className='event-details-bottom'>
                    <div className='event-start-time'>
                        <small>Starts at {this.props.event.startTimeLocal} </small>
                    </div>
                </div>
                {/* && this.props.event.event.finalized */}
                {/* this.props.event.event  &&  */}
               
                {this.props.event.status  && (this.props.event.status != "p") && (
                    <div class='alert'>
                        <small>
                            {(this.props.event.status == "w") ? "You won!" : null}
                            {(this.props.event.status == "l") ? "You lost!" : null}
                            {/* Team {this.props.event.event.winner} won! */}
                            </small>
                    </div>
                )}
            </figcaption>
        </figure>);
    }

}
export default EventCard;


// WEBPACK FOOTER //
// ./src/components/general/event/widgets/EventCard.js